import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Sparkles, MessageCircle } from "lucide-react";
import AuraChat from "./AuraChat";
import { supabase } from "@/integrations/supabase/client";

const AuraChatButton = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [userContext, setUserContext] = useState<any>(null);

  const handleClick = () => {
    setIsOpen(true);
  };

  useEffect(() => {
    const fetchUserContext = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return;

      const { data: profile } = await supabase
        .from("profiles")
        .select("symptoms, goals")
        .eq("user_id", user.id)
        .single();

      if (profile) {
        setUserContext({
          symptoms: profile.symptoms || [],
          goals: profile.goals || [],
        });
      }
    };

    fetchUserContext();
  }, []);

  // Hide on product pages
  if (location.pathname.startsWith('/product/')) {
    return null;
  }

  return (
    <>
      <Button
        onClick={handleClick}
        aria-label="Open Aura AI wellness chat"
        className="fixed bottom-6 right-6 w-14 h-14 rounded-full shadow-2xl z-50 bg-gradient-to-br from-primary to-primary/80 hover:scale-110 transition-transform animate-pulse hover:animate-none group"
        size="icon"
        title="Chat with Aura - Your AI Wellness Assistant"
      >
        <Sparkles className="w-6 h-6 group-hover:rotate-12 transition-transform" />
      </Button>

      {/* Tooltip hint */}
      {!isOpen && (
        <div className="fixed bottom-24 right-6 z-50 animate-fade-in">
          <div className="bg-primary text-primary-foreground px-4 py-2 rounded-lg shadow-lg text-sm font-medium whitespace-nowrap flex items-center gap-2">
            <MessageCircle className="h-4 w-4" /> Chat with Aura AI
            <div className="absolute -bottom-1 right-6 w-3 h-3 bg-primary transform rotate-45"></div>
          </div>
        </div>
      )}

      <AuraChat isOpen={isOpen} onClose={() => setIsOpen(false)} userContext={userContext} />
    </>
  );
};

export default AuraChatButton;
